import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { RewardsService } from '@features/rewards/rewards.service';
import { SessionService } from '@shared/session.service';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
  imports: [RouterLink, RouterLinkActive],
})
export class ProfileMenuComponent {
  constructor(public session: SessionService, public rewardsService: RewardsService) {}

  async reloadSteamLevel() {
    this.session.reloadSteamLevel();
  }
}
